import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
export function Header() {
  return <Box as="header" bg="#008080" h="64px" w="100%" position="fixed" top={0} left={0} zIndex={100} boxShadow="0 2px 4px rgba(0,0,0,0.2)" data-id="element-74">
      <Flex align="center" h="100%" px={4} gap={3} data-id="element-75">
        {/* Logo placeholder */}
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="md" bg="green.700" fontSize="22px" flexShrink={0} border="2px solid rgba(255,255,255,0.3)" data-id="element-76">
          🌿
        </Flex>
      </Flex>
    </Box>;
}